const state = {
  ano_selecionado: ''
}

const mutations = {
  setAno (state, value) {
    state.ano_selecionado = value
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ano.js